import { ButtonGroup, Heading, IconButton, Box } from '@chakra-ui/react';
import { FC } from 'react';
import { MdVerticalAlignBottom, MdVerticalAlignCenter, MdVerticalAlignTop } from 'react-icons/md';
import { useStore } from '../../../hooks/useStore';
import { shallow } from 'zustand/shallow';
import { AdElementText } from '@adflow/types';

type Props = {
  selectedElement: AdElementText;
};

const TextVerticalAlignmentControls: FC<Props> = ({ selectedElement }) => {
  const store = useStore(
    (state) => ({
      updateElementData: state.updateElementData,
    }),
    shallow,
  );

  const handleVerticalAlignment = (alignment: 'top' | 'center' | 'bottom') => {
    store.updateElementData(selectedElement.id, {
      ...selectedElement.data,
      style: {
        ...selectedElement.data.style,
        textAlignVertical: alignment,
      },
    });
  };

  const verticalAlign = selectedElement.data.style.textAlignVertical ?? 'center';

  return (
    <Box>
      <Heading fontSize="md" fontWeight="semibold">
        Vertical Align
      </Heading>
      <ButtonGroup size="sm" isAttached variant="outline" mt={2}>
        <IconButton
          backgroundColor={verticalAlign === 'top' ? '#F0F0F0' : 'none'}
          aria-label="Align Top"
          icon={<MdVerticalAlignTop />}
          onClick={() => handleVerticalAlignment('top')}
        />
        <IconButton
          backgroundColor={verticalAlign === 'center' ? '#F0F0F0' : 'none'}
          aria-label="Align Middle"
          icon={<MdVerticalAlignCenter />}
          onClick={() => handleVerticalAlignment('center')}
        />
        <IconButton
          backgroundColor={verticalAlign === 'bottom' ? '#F0F0F0' : 'none'}
          aria-label="Align Bottom"
          icon={<MdVerticalAlignBottom />}
          onClick={() => handleVerticalAlignment('bottom')}
        />
      </ButtonGroup>
    </Box>
  );
};

TextVerticalAlignmentControls.displayName = 'TextVerticalAlignmentControls';

export default TextVerticalAlignmentControls;
export type { Props as TextVerticalAlignmentControlsProps };
